<p-accordionTab class="therapy-card-container" [disabled]="isTherapyUncurated" [ngClass]="{'disable-accordion':isTherapyUncurated}">
  <p-header class="therapy-card-title">
    <div class="therapy-meta">
      <gen-therapy-tier
        class="tier-wrap"
        *ngIf="!!therapy.therapeuticQualifier || !!therapy.tier "
        [therapeuticQualifier]="therapy.therapeuticQualifier"
        [tier]="therapy.tier"></gen-therapy-tier>
      <div class="tier-spacer"
           *ngIf="!(!!therapy.therapeuticQualifier || !!therapy.tier)"></div>
        <gen-therapy-title-element class="therapy-title-meta-item"
                                   *ngFor="let title of titles"
                                   [icon]="title.icon"
                                   [subTitle]="title.subTitle"
                                   [value]="title.value"
                                   [classes]="title.automationClass +' '+ title.subTitle.split(' ').join('_').toLowerCase() "
                                   [modalData]="title.modalData"
                                   [modalTitle]="title.modalTitle"
        >
        </gen-therapy-title-element>
    </div>
    <div class="therapy-counter" [ngClass]="{'uncharacterized':isTherapyUncurated}">
      <div *ngIf="isTherapyUncurated" class="uncharacterized-container">
        <div class="uncharacterized-title Auto_TherapyMatches_Table_Item_Uncharacterized"
        >{{uncharacterizedTitle}}</div>
      </div>
      <div *ngIf="!isTherapyUncurated" class="characterized-container">
        <gen-counter-element [counter]="isWildTypeTherapyMatch ? 0 : (therapy.drugs && therapy.drugs.length ? therapy.drugs.length:0)"
                             [elementTitle]="therapy.drugs.length > 1 ? 'Therapy Matches':'Therapy Match'"
                             [automationClass]="'Auto_TherapyMatches_Table _Item_Therapies_match'"></gen-counter-element>
        <gen-counter-element [counter]="isWildTypeTherapyMatch ? 0 : (trials && trials.length ? trials.length: 0)"
                             [elementTitle]="trials && trials.length > 1 ? 'Clinical Trials': 'Clinical Trial'"
                             [automationClass]="'Auto_TherapyMatches_Table _Item_Clinicaltrias'"></gen-counter-element>
      </div>
    </div>
    <div  *ngIf="!isTherapyUncurated && isIncludeInReportVisible" class="report-selection">
      <label>{{includeInReportLabel}}</label>
      <gen-toggle-switch [active]=visibleInReport (click)="$event.stopPropagation()" [disabled]=checkboxDisabled (statusUpdate)="toggleSelection($event)"></gen-toggle-switch>
    </div>
    <gen-button *ngIf="therapyMatchEditConfiguration && !isTestCompleted"
                [iconClass]="'fa fa-pencil'"
                [type]="'quite'"
                (click)="openEditTherapy()"
    ></gen-button>
    <div *ngIf="!isTherapyUncurated" class="arrow glyphicon glyphicon-chevron-up" [ngClass]="{'open':show}"
         (click)="toggleCard()"></div>
    <div *ngIf="isTherapyUncurated"
         [ngClass]="uncharacterizedIconClass"
         class="arrow indicator-icon Auto_TherapyMatches_Table_Item_Uncharacterized_Icon"></div>
    <div  *ngIf="isTherapyUncurated && isIncludeInReportVisible" class="report-selection">
      <label>{{includeInReportLabel}}</label>
      <gen-toggle-switch [active]=visibleInReport (click)="$event.stopPropagation()" [disabled]=checkboxDisabled (statusUpdate)="toggleSelection($event)"></gen-toggle-switch>
    </div>
  </p-header>
  <section class="card-content open">
    <section class="therapies-information">
      <ng-container *ngIf="!isWildTypeTherapyMatch">
      <div class="drugs-lists-container">
        <gen-drug-list *ngFor="let drugList of drugsObject | objectToArray"
                       [type]="drugList.key"
                       [caseStatus]="caseStatus"
                       (onDrugListChanged)="checkDrugs($event)"
                       [drugObjects]="drugList.value"></gen-drug-list>
      </div>
      <section class="content-section" *ngIf="!!therapy.sentComment">
        <span class="title Auto_RequestComment_Title">Request Comment</span>
        <div class="content Auto_Request Comment_Text" *ngIf="!!therapy.sentComment">
          {{therapy.sentComment}}
        </div>
      </section>
      <section class="content-section ">
        <span class="title Auto_ResistanceInteractions_Title" [ngClass]="{'unavailable': !therapy.drugResistance}">Resistance and Interactions</span>
        <div class="content Auto_ResistanceInteractions_Text" *ngIf="!!therapy.drugResistance">
          {{therapy.drugResistance}}
        </div>
      </section>
      <section class="content-section ">
        <span class="title AutoGuidelines_Title"
              [ngClass]="{'unavailable':therapy.guidlines.length === 0}">Guidelines</span>
        <div class="content" *ngIf="therapy.guidlines.length > 0">
          <span class="guideline AutoGuidelines_Text" *ngFor="let guidlines of therapy.guidlines">
            {{guidlines.text}}
          </span>
        </div>
      </section>
      </ng-container>
      <section class="content-section">
        <span class="title Auto_TreatmentApproach_Title" [ngClass]="{'unavailable':!therapy.treatmentApproach}">Treatment approach</span>
        <div class="content Auto_TreatmentApproach_Text" *ngIf="!!therapy.treatmentApproach">
          {{therapy.treatmentApproach}}
        </div>
      </section>
      <ng-container *ngIf="!isWildTypeTherapyMatch">
      <span class="more-details Auto_Detailed_Therapy_Link"
            (click)="openModal('Detailed therapeutic relevance',therapy.theraputicRelevanceDetails)">
        Detailed therapeutic relevance
      </span>
      </ng-container>
    </section>
    <ng-container *ngIf="!isWildTypeTherapyMatch">
    <section class="clinical-trials-section">
      <gen-clinical-trials
        [trials]="trials||[]"></gen-clinical-trials>
    </section>
   </ng-container>
  </section>

</p-accordionTab>
